var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDoubleCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9062 7C11.9805 7 3.90625 15.0742 3.90625 25C3.90625 34.9258 11.9805 43 21.9062 43C31.832 43 39.9062 34.9258 39.9062 25C39.9062 15.0742 31.832 7 21.9062 7ZM30.75 7.09375C37.3398 10.3672 41.9062 17.1562 41.9062 25C41.9062 32.8477 37.3398 39.6328 30.75 42.9062C39.8047 41.9766 46.9062 34.2969 46.9062 25C46.9062 15.7031 39.8047 8.02734 30.75 7.09375ZM21 14H23V16.3125C25.8984 16.8125 26.8984 18.8008 27.5 21H25.5C25.1992 19.3984 24.1953 18.0938 22.0938 18.0938C19.0938 18.0938 18.6875 20.1016 18.6875 21C18.6875 23.1016 20.5859 23.5938 22.6875 24.0938C25.2891 24.6953 28 25.6055 28 28.9062C28 32.9062 24.5 33.9922 23 34.0938V36H21V34.0938C19.3008 33.793 16.3008 32.8008 16 28.5H18C18 29.8008 18.8984 32.1875 22 32.1875C25.1016 32.1875 25.8125 30.6953 25.8125 29.0938C25.8125 24.293 16.5 27.5859 16.5 21.1875C16.5 17.7891 19.3984 16.3867 21 16.1875V14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDoubleCoin);
export default __webpack_public_path__ + "static/media/white-double-coin.edf23c48d7908322bbc1500af27bc1c7.svg";
export { ForwardRef as ReactComponent };